import { DokazOIskljucenosti, RazlogIskljucenja } from "../../../index";
import { Box } from "@mui/material";
import { useForm, useFormContext } from "react-hook-form";
import dayjs from "dayjs";

const Index = () => {
  const { getValues } = useFormContext();
  const datumUlaska = getValues("datumUlaska");
  return (
    <div>
      <h4>Isključeni operater</h4>
      <div>
        <p>
          Datum ulaska u status isključenog operatera platforme: (Commencement date of reporting platform operator:)
          <strong> {dayjs(datumUlaska).format("DD/MM/YYYY")}</strong>
        </p>
        <p>
          Izvještajno razdoblje za koje operater platforme je u statusu
          isključenog operatera:{" "}
          <strong>{dayjs(datumUlaska).get("year")}. godina</strong>
        </p>
      </div>
      <Box sx={{ mt: 4, mb: 4 }}>
        <div>
          <strong>Priroda obveze izvješćivanja (Nature of reporting obligation):</strong>
        </div>
        <div>
          <p>
            <span>Nexus 1</span>
            <span> - </span>
            <span>Operater obveznik izvješćivanja u RH.</span>
          </p>
        </div>
      </Box>
      <RazlogIskljucenja />
      <DokazOIskljucenosti />
    </div>
  );
};

export default Index;
